import React from 'react';

const TFJS_Visor = () => {
    return (
        <div>TFJS_Visor Component</div>
    );
}

export default TFJS_Visor;
